import { render, staticRenderFns } from "./SectionCards.vue?vue&type=template&id=4be978c2&scoped=true"
import script from "./SectionCards.vue?vue&type=script&lang=js"
export * from "./SectionCards.vue?vue&type=script&lang=js"
import style0 from "./SectionCards.vue?vue&type=style&index=0&id=4be978c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be978c2",
  null
  
)

export default component.exports